import { Autocomplete, Box, Dialog, DialogTitle, DialogContent, DialogActions, Button, Checkbox, Divider, FormControl, FormControlLabel, Grid, IconButton, ListItemText, MenuItem, Radio, RadioGroup, Select, TextField, Tooltip, Typography, Tabs, Tab, CardContent, Card } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef, useCallback } from "react";
import { toast } from "react-toastify";
import DynamicTable from "../../../../Dynamic-table";
import { MedicineDose } from "../../../../OPD/add-patient-record/MedicineDoses";
import dayjs from "dayjs";
import CloseIcon from '@mui/icons-material/Close';
import StopIcon from '@mui/icons-material/Stop';
import InfoIcon from "@mui/icons-material/Info";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { isDateTimeGreaterThan30MinutesAgo } from "../../../../../utils/dateTimeUtils";
import CircleIcon from '@mui/icons-material/Circle';
import SignatureCanvas from 'react-signature-canvas';
import CancelIcon from '@mui/icons-material/Cancel';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useSelector } from "react-redux";
import FingerprintCaptureControls from "../../../../FingerprintCaptureControls";
import { useFingerprintCapture } from "../../../../../hooks/useFingerprintCapture";

interface TreatmentProps {
    onChange: (data: any) => void;
    data: any;
    otherTabsData: any;
    profile: any;
}

interface FormData {
    medicines: any[];
    transfusion: any[];
    stopped_medicines: any[];
    guidance: string;
    guidances: any[];
    created_By: string;
    created_At: any;
    consentForm?: {
        patientOrRelativeName: string;
        parentName: string;
        patientName: string;
        procedureName: string;
        risks: string;
        relationWithPatient: string;
        signature: string;
        doctorSignature: string;
        staffNameOrStamp: string;
        designation: string;
        date: any;
        time: string;
    };
}

const TreamentChart: React.FC<TreatmentProps> = ({ onChange, data, otherTabsData, profile }) => {
    const currentDate = dayjs();
    const [services, setServices] = useState<any[]>([]);
    const [id, setId] = useState("");
    const [routeAdm, setRouteAdm] = useState<any[]>([]);
    const [formData, setFormData] = useState<any>({
        medicines: [],
        transfusion: [],
        stopped_medicines: [],
        guidance: '',
        guidances: [],
        created_By: '',
        created_At: dayjs(),
        age: profile?.age || '', // Add age field
        consentForm: {
            patientOrRelativeName: profile?.fullName || '',
            parentName: '',
            patientName: profile?.fullName || '',
            procedureName: '',
            risks: '',
            relationWithPatient: '',
            signature: '',
            doctorSignature: '',
            staffNameOrStamp: '',
            designation: '',
            date: null,
            time: '',
            submitted: false, // <-- add this
        }
    });
    const [openStopDialog, setOpenStopDialog] = useState<boolean>(false);
    const [medicineToStop, setMedicineToStop] = useState<any>(null);
    const [openDelMed, setOpenDelMed] = useState<boolean>(false);
    const [selectedTab, setSelectedTab] = useState<any>(0);
    const [consentModalOpen, setConsentModalOpen] = useState<boolean>(false);
    const signatureRef = useRef<SignatureCanvas | null>(null);
    const doctorSignatureRef = useRef<SignatureCanvas | null>(null);
    const isSignaturePresent = !!formData?.consentForm?.signature;
    const [consentSubmitted, setConsentSubmitted] = useState(false);
  const Adminprofile = useSelector((state: any) => state.profileSlice.profile);

    useEffect(() => {
        onChange({ ...formData });
    }, [formData, onChange]);

    const handleCloseStopDialog = () => {
        setOpenDelMed(false);
    };

    const handleOpenStopDialog = () => {
        setOpenDelMed(true);
    };

    const handleTabChange = (event: any, newValue: any) => {
        if (newValue < formData?.stopped_medicines?.length) {
            setSelectedTab(newValue);
        } else {
            setSelectedTab(0);
        }
    };

    useEffect(() => {
        if (data?.consentForm) {
            setFormData((prev: any) => ({
                ...prev,
                age: profile?.age || data?.age || prev.age, // Preserve or update age
                consentForm: {
                    patientOrRelativeName: data?.consentForm?.patientOrRelativeName || profile?.fullName || '',
                    parentName: data?.consentForm?.parentName || '',
                    patientName: data?.consentForm?.patientName || profile?.fullName || '',
                    procedureName: data?.consentForm?.procedureName || '',
                    risks: data?.consentForm?.risks || '',
                    relationWithPatient: data?.consentForm?.relationWithPatient || '',
                    signature: data?.consentForm?.signature || '',
                    doctorSignature: data?.consentForm?.doctorSignature || '',
                    staffNameOrStamp: data?.consentForm?.staffNameOrStamp || '',
                    designation: data?.consentForm?.designation || '',
                    date: data?.consentForm?.date ? dayjs(data?.consentForm?.date) : null,
                    time: data?.consentForm?.time || '',
                    submitted: data?.consentForm?.submitted || false, // <-- add this
                }
            }));
        }
    }, [data, profile]);

    useEffect(() => {
        onChange({ ...formData });
    }, [formData]);

    const mergeMedicines = (existingMedicines = [], newMedicines = [], stopped_medicines = []) => {
        const existingMedicinesMap = new Map(existingMedicines?.map((medicine: any) => [medicine?.id, medicine]));
        const deletedMedicineIds = new Set(stopped_medicines?.map((medicine: any) => medicine?.id));
        newMedicines?.forEach((newMedicine: any) => {
            if (deletedMedicineIds?.has(newMedicine.id)) {
                return;
            }
            const existingMedicine = existingMedicinesMap?.get(newMedicine.id);

            if (existingMedicine) {
                existingMedicinesMap?.set(newMedicine?.id, { ...existingMedicine, ...newMedicine });
            } else {
                existingMedicinesMap?.set(newMedicine.id, newMedicine);
            }
        });
        existingMedicinesMap?.forEach((medicine, id) => {
            if (deletedMedicineIds?.has(id)) {
                existingMedicinesMap?.delete(id);
            }
        });

        
        return Array.from(existingMedicinesMap?.values());
    };

    const mergeTransfusions = (existingTransfusions = [], newTransfusions = []) => {
        const existingTransfusionsMap = new Map(existingTransfusions?.map((transfusion: any) => [transfusion?.id, transfusion]));
        newTransfusions?.forEach((newTransfusion: any) => {
            const existingTransfusion = existingTransfusionsMap?.get(newTransfusion.id);
            if (existingTransfusion) {
                existingTransfusionsMap?.set(newTransfusion?.id, { ...existingTransfusion, ...newTransfusion });
            } else {
                existingTransfusionsMap?.set(newTransfusion.id, newTransfusion);
            }
        });
        return Array.from(existingTransfusionsMap?.values());
    };

    const fetchFormData = async (formName: string) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_IPD_API_URL}/ipd-form-data/getFormDataBySearchId/${otherTabsData?._id}?formName=${formName}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            const fetchedData = await response?.data?.data?.formData;
            setFormData((prevData: any) => ({
                ...prevData,
                guidance: fetchedData?.guidance || '',
                guidances: fetchedData?.guidances || [],
                medicines: mergeMedicines(prevData?.medicines || [], fetchedData?.medicines || []),
                transfusion: mergeTransfusions(prevData?.transfusion, fetchedData?.transfusion),
                created_By: fetchedData?.created_By || '',
                created_At: dayjs(fetchedData?.created_At),
                age: profile?.age || fetchedData?.age || prevData.age, // Add age
            }));
            setId(response?.data?.data?.searchId);
        } catch (error) {
            toast.error('Failed to fetch form data.');
        }
    };
    // Add a useEffect to update age when profile changes
    useEffect(() => {
        if (profile?.age) {
            setFormData((prev: any) => ({
                ...prev,
                age: profile.age, // Store age in formData
            }));
        } else if (profile?.dateOfBirth) {
            // Calculate age from dateOfBirth if available
            const age = dayjs().diff(dayjs(profile.dateOfBirth), 'year');
            setFormData((prev: any) => ({
                ...prev,
                age,
            }));
        }
    }, [profile]);
    useEffect(() => {
        fetchFormData('Treatment');
    }, []);

    useEffect(() => {
        if (data) {
            setFormData((prevState: any) => ({
                ...prevState,
                medicines: mergeMedicines(prevState?.medicines || [], data?.medicines || [], data?.stopped_medicines || []),
                transfusion: mergeTransfusions(prevState?.transfusion, data?.transfusion),
                stopped_medicines: data?.stopped_medicines || [],
                created_By: data?.created_By || '',
                created_At: dayjs(data?.created_At)
            }));
        }
    }, [data]);


    // Hypothetical function to add a new transfusion record
    const handleAddTransfusion = async (newTransfusion: any) => {
        try {
            // Save to backend (adjust URL and payload as needed)
            const response = await axios.post(
                `${process.env.REACT_APP_IPD_API_URL}/ipd-form-data/addTransfusion`,
                { ...newTransfusion, searchId: otherTabsData?._id },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const savedTransfusion = response.data.data;
            // Update formData with the new transfusion
            setFormData((prev: any) => ({
                ...prev,
                transfusion: [...prev.transfusion, savedTransfusion],
            }));
            // Optionally, refetch data to ensure consistency
            await fetchFormData('Treatment');
        } catch (error) {
            toast.error('Failed to add transfusion.');
        }
    };




    useEffect(() => {
        onChange({ ...formData, transfusion: formData?.transfusion });
    }, [formData?.transfusion]);

    const handleConsentFormChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData((prev: any) => ({
            ...prev,
            consentForm: {
                ...prev.consentForm,
                [name]: value,
            },
        }));
    };
    const handleFingerprintCaptured = useCallback((fingerprintDataUrl: string) => {
        signatureRef.current?.clear();
        setFormData((prev: any) => ({
            ...prev,
            consentForm: {
                ...prev.consentForm,
                signature: fingerprintDataUrl,
            },
        }));
    }, []);

    const handleDoctorFingerprintCaptured = useCallback(
        (fingerprintDataUrl: string) => {
            doctorSignatureRef.current?.clear();
            setFormData((prev: any) => ({
                ...prev,
                consentForm: {
                    ...prev.consentForm,
                    doctorSignature: fingerprintDataUrl,
                },
            }));
        },
        []
    );

    const {
        fingerprintDevice,
        detectingDevice,
        capturingFingerprint,
        isFingerprintImage,
        setIsFingerprintImage,
        detectDevice,
        captureFingerprint,
        syncFingerprintFlag,
    } = useFingerprintCapture({ onCaptured: handleFingerprintCaptured });

    const {
        fingerprintDevice: doctorFingerprintDevice,
        detectingDevice: detectingDoctorDevice,
        capturingFingerprint: capturingDoctorFingerprint,
        isFingerprintImage: isDoctorFingerprintImage,
        setIsFingerprintImage: setIsDoctorFingerprintImage,
        detectDevice: detectDoctorDevice,
        captureFingerprint: captureDoctorFingerprint,
        syncFingerprintFlag: syncDoctorFingerprintFlag,
    } = useFingerprintCapture({ onCaptured: handleDoctorFingerprintCaptured });

    const handleSignatureEnd = () => {
        const signature = signatureRef.current?.toDataURL();
        setIsFingerprintImage(false);
        setFormData((prev: any) => ({
            ...prev,
            consentForm: {
                ...prev.consentForm,
                signature,
            },
        }));
    };

    const handleDoctorSignatureEnd = () => {
        const doctorSignature = doctorSignatureRef.current?.toDataURL();
        setIsDoctorFingerprintImage(false);
        setFormData((prev: any) => ({
            ...prev,
            consentForm: {
                ...prev.consentForm,
                doctorSignature,
            },
        }));
    };

    const clearSignature = () => {
        if (signatureRef.current) {
            signatureRef.current.clear();
        }
        setIsFingerprintImage(false);
        setFormData((prev: any) => ({
            ...prev,
            consentForm: {
                ...prev.consentForm,
                signature: '',
            },
        }));
    };

    const clearDoctorSignature = () => {
        if (doctorSignatureRef.current) {
            doctorSignatureRef.current.clear();
        }
        setIsDoctorFingerprintImage(false);
        setFormData((prev: any) => ({
            ...prev,
            consentForm: {
                ...prev.consentForm,
                doctorSignature: '',
            },
        }));
    };

    const handleConsentModalClose = () => {
        setConsentModalOpen(false);

    };

    const handleConsentFormSubmit = () => {
        // Validate required fields
        if (!formData?.consentForm?.patientOrRelativeName?.trim()) {
            toast.error('Please provide the patient or guardian name.');
            return;
        }
        if (!formData?.consentForm?.signature) {
            toast.error('Please provide a signature or thumb before submitting.');
            return;
        }
        if (!formData?.consentForm?.date || !dayjs(formData?.consentForm?.date).isValid()) {
            toast.error('Please provide a valid date.');
            return;
        }

        // Set submitted flag
        setFormData((prev: any) => ({
            ...prev,
            consentForm: {
                ...prev.consentForm,
                submitted: true,
            },
        }));

        setConsentSubmitted(true);
        onChange({ ...formData, consentForm: { ...formData?.consentForm, submitted: true } });
        setConsentModalOpen(false);
    };
    useEffect(() => {
        if (formData?.consentForm?.submitted) {
            setConsentSubmitted(true);
        }
    }, [formData?.consentForm?.submitted]);
    const getAllocatedServices = async (id: any) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_IPD_API_URL}/ipd-services-allocation/getAll_allocateServices/${id}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );
            if (response?.data?.isSuccess) {
                setServices(response?.data?.data || []);
            }
        } catch (error) {
            console.error("Error fetching admission information:", error);
        }
    };

    useEffect(() => {
        if (id) {
            getAllocatedServices(id);
        }
    }, [id]);

    // // Reload signature into canvas
    // useEffect(() => {
    //     if (formData.consentForm.signature && signatureRef.current && consentModalOpen) {
    //         signatureRef.current.clear();
    //         try {
    //             signatureRef.current.fromDataURL(formData.consentForm.signature, {
    //                 ratio: window.devicePixelRatio || 1,
    //             });
    //         } catch (error) {
    //             console.error('Error loading signature data:', error);
    //         }
    //     }
    // }, [formData.consentForm.signature, consentModalOpen]);

    const handleDeleteGivenBy = (medicineName: string, idx: number) => {
        if (!formData || !formData?.medicines) return;
        const updatedMedicines = formData?.medicines?.map((med: any) => {
            if (med === medicineName) {
                const updatedGivenBy = med?.med_History?.filter((_: any, index: number) => index !== idx);
                return {
                    ...med,
                    med_History: updatedGivenBy,
                };
            }
            return med;
        });
        setFormData((prevState: any) => ({
            ...prevState,
            medicines: updatedMedicines,
        }));
    };
    // ...existing code...

    useEffect(() => {
        // Set default date/time if not already set
        if (consentModalOpen && !formData?.consentForm?.date) {
            setFormData((prev: any) => ({
                ...prev,
                consentForm: {
                    ...prev.consentForm,
                    date: dayjs(),
                    time: dayjs().format("hh:mm A"),
                },
            }));
        }
    }, [consentModalOpen]);

    // ...existing code...
    const getRouteAdm = async () => {
        const response = await axios.get(
            `${process.env.REACT_APP_OPD_API_URL}/routes-of-administration/getAllByPagination`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                params: {
                    count: 50000,
                    pageNo: 1,
                },
            }
        );
        setRouteAdm(response.data?.data);
    };

    useEffect(() => {
        getRouteAdm();
    }, []);

    const formatDateTime = (dateTime: string) => {
        if (!dateTime) return { date: 'No date available', time: 'No time available' };
        const dayjsDate = dayjs(dateTime, 'DD.MM.YYYY hh:mm A');
        return {
            date: dayjsDate.format('DD.MMM.YYYY'),
            time: dayjsDate.format('hh:mm A'),
        };
    };

    useEffect(() => {
        onChange({ ...formData, medicines: formData?.medicines, transfusion: data?.transfusion });
    }, [formData]);

    const handleContinue = (medicine: any) => {
        const doctorName = profile?.data?.fullName;
        const startedAt = currentDate.format('DD.MM.YYYY hh:mm A');
        const updatedMedicines = formData?.medicines?.map((med: any) => {
            if (med === medicine) {
                if (med?.status === 'started') return med;
                const updatedStatusHistory = [
                    ...(med?.med_History || []),
                    {
                        status: 'started',
                        date_Time: startedAt,
                        doctorName,
                        action: 'started',
                    },
                ];
                return {
                    ...med,
                    status: 'started',
                    med_History: updatedStatusHistory,
                };
            }
            return med;
        });
        setFormData({ ...formData, medicines: updatedMedicines });
    };

    const handleGivenBy = (medicine: MedicineDose) => {
        const doctorName = profile?.data?.fullName;
        const givenAt = currentDate.format('DD.MM.YYYY hh:mm A');

        const updatedMedicines = formData?.medicines?.map((med: any) => {
            if (med === medicine) {
                const updatedStatusHistory = [
                    ...(med?.med_History || []),
                    {
                        status: 'given',
                        date_Time: givenAt,
                        doctorName,
                        action: 'given',
                    },
                ];
                return {
                    ...med,
                    med_History: updatedStatusHistory,
                };
            }
            return med;
        });
        setFormData({ ...formData, medicines: updatedMedicines });
    };

    const handleStopClick = (medicine: any) => {
        setMedicineToStop(medicine);
        setOpenStopDialog(true);
    };

    const handleStopMedicine = () => {
        if (!medicineToStop) return;

        const doctorName = profile?.data?.fullName;
        const stoppedAt = currentDate.format('DD.MM.YYYY hh:mm A');
        const updatedMedicines = formData?.medicines?.map((med: any) => {
            if (med?.name === medicineToStop?.name) {
                const updatedStatusHistory = [
                    ...(med?.med_History || []),
                    {
                        status: 'stopped',
                        date_Time: stoppedAt,
                        doctorName,
                        action: 'stopped',
                    },
                ];
                return {
                    ...med,
                    status: 'stopped',
                    med_History: updatedStatusHistory,
                };
            }
            return med;
        });

        const updatedDeletedMedicines = [
            ...(formData?.stopped_medicines || []),
            { ...medicineToStop, stoppedAt, doctorName },
        ];

        setFormData({
            ...formData,
            medicines: updatedMedicines.filter((med: any) => med?.name !== medicineToStop?.name),
            stopped_medicines: updatedDeletedMedicines,
        });

        setOpenStopDialog(false);
        setMedicineToStop(null);
    };

    const handleCancelStop = () => {
        setOpenStopDialog(false);
        setMedicineToStop(null);
    };

    const [stopReasonDialogOpen, setStopReasonDialogOpen] = useState(false);
    const [reason, setReason] = useState("");
    const [transfusionToStop, setTransfusionToStop] = useState<any>(null);
    const [selectedTransfusion, setSelectedTransfusion] = useState<any>(null);
    const [selectedTransfuseTab, setSelectedTransfuseTab] = useState(0);

    const handleTransfuseTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setSelectedTransfuseTab(newValue);
    };

    const handleDeleteGivenHistory = (transfusionId: string, history: any) => {
        const updatedTransfusions = formData?.transfusion?.map((item: any) => {
            if (item?.id === transfusionId) {
                const updatedHistory = item?.transfuse_History?.filter((h: any) => h !== history);
                return { ...item, transfuse_History: updatedHistory };
            }
            return item;
        });

        setFormData({ ...formData, transfusion: updatedTransfusions });
    };

    const handleStartTransfusion = (transfusionId: number) => {
        const doctorName = profile?.data?.fullName;
        const startedAt = dayjs().format("DD.MM.YYYY hh:mm A");
        const age = profile?.age || (profile?.dateOfBirth ? dayjs().diff(dayjs(profile.dateOfBirth), 'year') : '');
        const updatedTransfusions = formData?.transfusion?.map((item: any) => {
            if (item?.id === transfusionId && item?.action !== "started") {
                const updatedHistory = [
                    ...(item.transfuse_History || []),
                    { action: "started", date_Time: startedAt, doctorName, age },

                ];
                return {
                    ...item,
                    action: "started",
                    transfuse_History: updatedHistory,
                    lastAdvised: { action: "Started", date_Time: startedAt, doctorName },
                };
            }
            return item;
        });

        setFormData({ ...formData, transfusion: updatedTransfusions });
    };

    const handleStopTransfusion = (transfusionId: number) => {
        const transfusionToStop = formData?.transfusion?.find((item: any) => item.id === transfusionId);
        setTransfusionToStop(transfusionToStop);
        setStopReasonDialogOpen(true);
    };

    const handleConfirmStop = () => {
        const doctorName = profile?.data?.fullName;
        const stoppedAt = dayjs().format("DD.MM.YYYY hh:mm A");
        const updatedTransfusions = formData?.transfusion?.map((item: any) => {
            if (item?.id === transfusionToStop?.id) {
                const updatedHistory = [
                    ...(item.transfuse_History || []),
                    { action: "stopped", date_Time: stoppedAt, doctorName, reason },
                ];
                return {
                    ...item,
                    action: "stopped",
                    transfuse_History: updatedHistory,
                    stoppedAt,
                    reason,
                };
            }
            return item;
        });
        setFormData({ ...formData, transfusion: updatedTransfusions });
        setStopReasonDialogOpen(false);
        setReason('');
    };

    const handleGiven = (transfusionId: number) => {
        const doctorName = profile?.data?.fullName;
        const dateTime = dayjs().format("DD.MM.YYYY hh:mm A");
        const updatedTransfusions = formData.transfusion.map((item: any) => {
            if (item.id === transfusionId) {
                const updatedHistory = [
                    ...(item.transfuse_History || []),
                    { action: "Given", date_Time: dateTime, doctorName },
                ];
                return { ...item, transfuse_History: updatedHistory };
            }
            return item;
        });

        setFormData({ ...formData, transfusion: updatedTransfusions });
    };

    const [selectedTransfusionId, setSelectedTransfusionId] = useState<any>();
    const [completionTime, setCompletionTime] = useState<string>("");
    const [doctorName, setDoctorName] = useState<string>("");
    const [completionDialogOpen, setCompletionDialogOpen] = useState(false);
    const [completionNotes, setCompletionNotes] = useState("");

    const handleCompleteTransfusion = (transfusionId: number) => {
        const selectedTransfusion = formData.transfusion.find((item: any) => item.id === transfusionId);

        setSelectedTransfusionId(transfusionId);
        setCompletionTime(selectedTransfusion?.action === "completed" ? selectedTransfusion?.completedAt : dayjs().format("DD.MM.YYYY hh:mm A"));
        setDoctorName(selectedTransfusion?.action === "completed" ? selectedTransfusion?.doctorName : profile?.data?.fullName || "");
        setCompletionNotes(selectedTransfusion?.action === "completed" ? selectedTransfusion?.completionNotes : "");
        setCompletionDialogOpen(true);
    };

    const handleConfirmCompletion = () => {
        const updatedTransfusions = formData.transfusion.map((item: any) => {
            if (item.id === selectedTransfusionId) {
                const updatedHistory = [
                    ...(item.transfuse_History || []),
                    { action: "Completed", date_Time: completionTime, doctorName, notes: completionNotes },
                ];
                return {
                    ...item,
                    transfuse_History: updatedHistory,
                    action: "completed",
                    completedAt: completionTime,
                    completionNotes,
                    doctorName
                };
            }
            return item;
        });

        setFormData({ ...formData, transfusion: updatedTransfusions });
        setCompletionDialogOpen(false);
    };

    const handleOpenDialog = (transfusion: any) => {
        setSelectedTransfusion(transfusion);
    };

    const handleCloseDialog = () => {
        setSelectedTransfusion(null);
        setReason('');
    };

    return (
        <>
            <Grid container spacing={1}>
                {formData?.guidance && <Grid item md={2} sm={3} xs={4}>
                    <Box sx={{ bgcolor: "rgba(223, 234, 255, 1)", border: "1px solid rgba(5, 95, 252, 1)", padding: "1px", borderRadius: "8px" }}>
                        <Typography sx={{ fontSize: '10px', fontWeight: '600' }}>
                            OPD Guidance
                        </Typography>
                        <Typography sx={{ fontSize: '10px', fontWeight: '600' }}>{formData?.guidance}
                        </Typography >
                        <Typography sx={{ fontSize: '10px', color: 'gray' }}>
                            {formData?.created_By} {dayjs(formData?.created_At).format('DD.MM.YYYY hh:mm A')}
                        </Typography>
                    </Box>
                </Grid>
                }
                {
                    formData?.guidances?.map((g: any, idx: any) => (
                        <Grid item md={2} sm={3} xs={4}>
                            <Box sx={{ bgcolor: "rgba(223, 234, 255, 1)", borderRadius: '8px', border: "1px solid rgba(5, 95, 252, 1)", display: 'flex', flexDirection: 'column', padding: '2px', whiteSpace: 'pre-line' }}>
                                <Tooltip title={g?.guidance} arrow placement="top">
                                    <Typography
                                        sx={{
                                            fontSize: '10px',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 1,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            height: '40px',
                                        }}
                                    >
                                        {g?.guidance}
                                    </Typography>
                                </Tooltip>
                                <Typography sx={{ fontSize: '10px', color: 'gray', mt: 1 }}>
                                    {g?.doctor_Name} {dayjs(g?.date_Time).format('DD.MM.YYYY hh:mm A')}
                                </Typography>
                            </Box>
                        </Grid>
                    ))
                }
            </Grid>
            <Typography sx={{ fontSize: '14px', fontWeight: '600', mt: 1 }} >Services</Typography>
            <DynamicTable
                headers={[
                    "SN",
                    "Services",
                    "Charge Type",
                    "Charges",
                    "Discount",
                    "Net Charges",
                ]}
                data={services?.map((item: any, index: any) => [
                    index + 1,
                    item?.ipdServices?.serviceName,
                    item?.ipdServices?.chargeType,
                    item?.ipdServices?.charges,
                    item?.discountRS,
                    item?.ipdServices?.charges - item?.discountRS,
                ])}
            />
            <Box display='flex' justifyContent='space-between' alignItems='center'>
                <Typography sx={{ fontSize: '14px', fontWeight: '600', mt: 1 }}>Medicine</Typography>
                <Button variant="contained" color='secondary' onClick={handleOpenStopDialog} size="small" >Stopped Medicines</Button>
            </Box>
            <DynamicTable
                headers={[
                    "SN",
                    "Medicine",
                    "Strength",
                    "Unit",
                    "Dosage",
                    "Route",
                    "Frequency",
                    "Duration",
                    "Doctor Name",
                    "Date & Time",
                    "Note"
                ]}
                data={formData?.medicines?.map((item: any, index: any) => [
                    index + 1,
                    item?.name,
                    item?.strength,
                    item?.medicineUnit,
                    item?.dosage,
                    (() => {
                        const route = routeAdm?.find(
                            (route: any) =>
                                route?._id === item?.routAdministrationId
                        );
                        return route ? route?.RA_Abbreviation : "-";
                    })(),
                    item?.frequency?.abr_notation,
                    item?.duration,
                    item?.doctorName || "-",
                    item?.dateTime || dayjs(item?.dateAndTime).format('DD.MM.YYYY hh:mm A'),
                    item?.note
                ])}
            />
            <Grid container>
                <Grid item md={12} sm={12} xs={12} sx={{ mt: 1 }}>
                    {Array.isArray(formData?.medicines) && formData?.medicines?.length > 0 && (
                        <Box display="flex" gap={2} flexWrap="wrap">
                            {Array.isArray(formData?.medicines) && formData?.medicines?.map((medicine: any, index: any) => {
                                if (!medicine) return null;
                                return (
                                    <Box
                                        key={index}
                                        sx={{
                                            backgroundColor: '#F5F5FB',
                                            padding: '8px',
                                            borderRadius: '8px',
                                            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                                            width: '180px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            maxHeight: '200px',
                                            overflowY: 'auto',
                                            '&::-webkit-scrollbar': {
                                                width: '4px',
                                            },
                                            '&::-webkit-scrollbar-thumb': {
                                                backgroundColor: '#888',
                                                borderRadius: '10px',
                                            },
                                            '&::-webkit-scrollbar-thumb:hover': {
                                                backgroundColor: '#555',
                                            },
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                textAlign: 'center',
                                                color: '#077DD3',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                width: '100%',
                                            }}
                                        >
                                            {medicine?.name}
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                {medicine?.status === 'started' ? (
                                                    <Tooltip placement="top" title="Stop">
                                                        <IconButton
                                                            size="small"
                                                            // color="primary"
                                                            onClick={() => handleStopClick(medicine)}
                                                        >
                                                            <StopIcon fontSize="small" sx={{ color: 'red' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip placement="top" title="Start" >
                                                        <IconButton
                                                            size="small"
                                                            color="primary"
                                                            onClick={() => handleContinue(medicine)}
                                                        >
                                                            <PlayArrowIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </Box>
                                        </Typography>
                                        <Divider sx={{ width: '100%', mb: 0.2 }} />

                                        <Box mt={0.5} mb={0.5}>
                                            {
                                                Array.isArray(medicine?.med_History) && medicine?.med_History
                                                    ?.map((item: any, idx: any) => {
                                                        const { date, time } = formatDateTime(item?.date_Time);
                                                        let displayIndex = null;
                                                        const givenItems = medicine?.med_History?.filter((item: any) => item?.status === 'given');
                                                        const givenIndex = givenItems?.findIndex((givenItem: any) => givenItem === item);

                                                        if (item?.status === 'given') {
                                                            displayIndex = givenIndex + 1;
                                                        }
                                                        return (
                                                            <>
                                                                <Box>
                                                                    <Box display="flex" alignItems="center" gap={2}>
                                                                        {displayIndex !== null && (
                                                                            <span style={{ fontSize: '10px', fontWeight: '600' }}>
                                                                                {displayIndex}:
                                                                            </span>
                                                                        )}
                                                                        <Typography sx={{
                                                                            fontSize: '10px',
                                                                            color: item?.status === 'given' ? '#000' : item?.status === 'started' ? 'blue' : item?.status === 'stopped' ? 'red' : 'gray',
                                                                            textTransform: 'capitalize'
                                                                        }}>
                                                                            {item?.status} at: {time}
                                                                        </Typography>
                                                                        {item?.status === 'given' && item?.doctorName === profile?.data?.fullName && (
                                                                            <Tooltip title="Delete" placement="top">
                                                                                <IconButton
                                                                                    size="small"
                                                                                    disabled={!isDateTimeGreaterThan30MinutesAgo(item?.date_Time)}
                                                                                    onClick={() => handleDeleteGivenBy(medicine, idx)}
                                                                                    sx={{ color: 'red', height: 12, width: 12 }}
                                                                                >
                                                                                    <CloseIcon fontSize="small" />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        )}
                                                                    </Box>
                                                                    <Typography sx={{ fontSize: '10px', color: 'gray', marginTop: 0.3 }}>
                                                                        {item?.doctorName}
                                                                        <span style={{ fontSize: '10px', color: 'gray' }}> {date} </span>
                                                                    </Typography>
                                                                </Box>
                                                                <Divider sx={{ width: '100%', mb: 0.2 }} />
                                                            </>
                                                        );
                                                    })
                                            }
                                            <Box mt={1} display="flex" justifyContent="center">
                                                {medicine?.status === 'started' && (
                                                    <Button
                                                        size="small"
                                                        variant="contained"
                                                        onClick={() => handleGivenBy(medicine)}
                                                        sx={{ mt: 'auto', color: '#fff' }}
                                                        color="success"
                                                    >
                                                        Given
                                                    </Button>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                );
                            })}
                        </Box>
                    )}
                </Grid>
            </Grid>


            <Box mt={1} sx={{ width: '100%' }} >

                <Box display='flex' justifyContent='space-between' alignItems='center' mb={1}>
                    <Typography variant="h3" sx={{ fontSize: '14px', fontWeight: '600' }} >Transfusions</Typography>
                    <Button variant="contained" color="primary" size="small" onClick={() => {
                        setConsentModalOpen(true);
                        syncFingerprintFlag(formData?.consentForm?.signature);
                        syncDoctorFingerprintFlag(formData?.consentForm?.doctorSignature);
                        detectDevice(false);
                        detectDoctorDevice(false);
                    }}>
                        Consent Form
                    </Button>
                </Box>

                <Box display="flex"
                    flexWrap="wrap"
                    gap={2}
                >
                    {formData?.transfusion?.map((transfusion: any, index: any) => (
                        <Card key={index} sx={{
                            boxShadow: 3, position: 'relative', width: { md: 'calc(16.6% - 16px)', sm: 'calc(25% - 16px)', xs: 'calc(50% - 16px)' },
                            maxHeight: '200px',
                            overflowY: 'auto',
                            '&::-webkit-scrollbar': {
                                width: '4px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                backgroundColor: '#555',
                            },
                            borderRadius: '12px', marginTop: '0px',
                        }}>
                            <CardContent sx={{ padding: '4px' }}>
                                <Box display='flex' justifyContent='space-between' alignItems='center'>
                                    <Typography variant="h6" sx={{ fontSize: '12px', fontWeight: 'bold', }}>{transfusion?.bloodTransfusion}</Typography>
                                    <Box >
                                        {transfusion?.action !== "completed" && (
                                            <>
                                                {transfusion?.action === "started" ? (
                                                    <Tooltip title="Stop" placement="top">
                                                        <IconButton size="small" onClick={() => handleStopTransfusion(transfusion.id)}>
                                                            <StopIcon fontSize="small" sx={{ color: "red" }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip title="Start" placement="top">
                                                        <IconButton size="small" onClick={() => handleStartTransfusion(transfusion.id)}>
                                                            <PlayArrowIcon fontSize="small" sx={{ color: "green" }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </>
                                        )}
                                        <Tooltip title="Complete" placement="top">
                                            <IconButton size="small" onClick={() => handleCompleteTransfusion(transfusion.id)}>
                                                <CircleIcon fontSize="small" sx={{ color: "blue" }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </Box>
                                <Typography variant="body2" sx={{ fontSize: '10px' }}>
                                    Components: {transfusion?.components?.join(", ")}
                                </Typography>
                                <Typography variant="body2" sx={{ fontSize: '10px' }}>
                                    {transfusion?.bloodTransfusion === "Arrange" ? transfusion?.pint + " pint" : transfusion?.quantity + " ml"}
                                </Typography>
                                <Divider />

                                <Box mt={0.5}>
                                    {transfusion?.transfuse_History?.map((history: any, idx: number) => (
                                        <>
                                            <Box key={idx} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <Box>
                                                    <Typography variant="body2" sx={{ fontSize: "10px", color: history?.action === "stopped" ? 'red' : history?.action === "started" ? 'green' : history?.action === "Completed" ? 'blue' : 'gray' }}>
                                                        {history?.action} At: {history?.date_Time}
                                                    </Typography>
                                                    <Typography sx={{ fontSize: "10px", color: history?.action === "stopped" ? 'red' : history?.action === "started" ? 'green' : history?.action === "Completed" ? 'blue' : 'gray' }} variant="body2">
                                                        {history?.doctorName}
                                                    </Typography>
                                                    {history?.action === "stopped" && <Typography sx={{ fontSize: "10px", color: 'red' }} variant="body2">
                                                        {history?.reason}
                                                    </Typography>}
                                                    {history?.action === "Completed" && <Typography sx={{ fontSize: "10px", color: 'blue' }} variant="body2">
                                                        {history?.notes}
                                                    </Typography>}
                                                </Box>
                                                {history?.action === "Given" && <Tooltip title="Delete" placement="top" arrow>
                                                    <IconButton sx={{ color: 'red' }}
                                                        size="small"
                                                        onClick={() => handleDeleteGivenHistory(transfusion?.id, history)}
                                                        disabled={!isDateTimeGreaterThan30MinutesAgo(history?.date_Time)}
                                                    >
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>}
                                            </Box>
                                            <Divider sx={{ width: '100%', mt: 0.2, mb: 0.2 }} />
                                        </>
                                    )
                                    )}
                                </Box>

                                <Box display="flex" justifyContent="center" gap={1} mt={2}>
                                    {transfusion?.action === "started" && (
                                        <Button size="small"
                                            variant="outlined"
                                            onClick={() => handleGiven(transfusion?.id)}
                                        >
                                            Given
                                        </Button>
                                    )}
                                </Box>
                            </CardContent>
                        </Card>
                    ))}
                </Box>




                <Dialog open={consentModalOpen} onClose={handleConsentModalClose} maxWidth="md" fullWidth>
                    <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', py: 1, position: 'relative' }}>
                        <IconButton
                            aria-label="close"
                            onClick={handleConsentModalClose}
                            sx={{ position: 'absolute', right: 8, top: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className="urduNotationFont" sx={{ direction: 'rtl', lineHeight: 2.2, fontWeight: 700, whiteSpace: 'nowrap', fontSize: '20px', px: 4 }}>
                            خون یا خون کے اجزاء کی منتقلی کے لیے رضامندی
                        </Typography>
                    </DialogTitle>
                    <DialogContent sx={{ p: 3 }}>
                        <Box component="form" onSubmit={(e) => { e.preventDefault(); handleConsentFormSubmit(); }}>
                            <Typography
                                variant="body2"
                                paragraph
                                className="urduNotationFont"
                                sx={{ fontSize: '15px', lineHeight: 2.3, textAlign: 'right', direction: 'rtl' }}
                            >
                                ڈاکٹر نے مجھے / ہمیں بتایا ہے کہ میرے / ہمارے مریض کی بیماری کے علاج کے لیے خون یا خون کے اجزاء کی منتقلی ضروری ہو سکتی ہے۔ خون کی منتقلی کے دوران اور بعد میں مختلف خطرات اور پیچیدگیاں ہو سکتی ہیں، جن میں بخار، الرجی، انفیکشن کی منتقلی اور دیگر ردِعمل شامل ہیں۔ بعض پیچیدگیاں سنگین یا جان لیوا بھی ہو سکتی ہیں۔
                            </Typography>
                            <Typography
                                variant="body2"
                                paragraph
                                className="urduNotationFont"
                                sx={{ fontSize: '15px', lineHeight: 2.3, textAlign: 'right', direction: 'rtl' }}
                            >
                                مجھے / ہمیں خون کی منتقلی کے فوائد، ممکنہ خطرات اور پیچیدگیوں کے بارے میں آگاہ کر دیا گیا ہے۔ میں / ہم اپنی رضامندی سے اپنے مریض کو خون یا خون کے اجزاء لگانے کی اجازت دیتے ہیں۔
                            </Typography>

                            <Box display="flex" alignItems="center" gap={2} dir="rtl" sx={{ mt: 1 }}>
                                <Box display="flex" alignItems="center" gap={1} sx={{ flex: 1.4, minWidth: 0 }}>
                                    <Typography className="urduNotationFont" sx={{ fontSize: '15px', whiteSpace: 'nowrap' }}>
                                        مریض/سرپرست کا نام:
                                    </Typography>
                                    <TextField
                                        name="patientOrRelativeName"
                                        value={formData?.consentForm?.patientOrRelativeName || ''}
                                        onChange={handleConsentFormChange}
                                        size="small"
                                        variant="standard"
                                        fullWidth
                                        dir="ltr"
                                        inputProps={{ dir: 'ltr', style: { direction: 'ltr', textAlign: 'left', fontSize: '15px' } }}
                                    />
                                </Box>
                                <Box display="flex" alignItems="center" gap={1} sx={{ flex: 1, minWidth: 0 }}>
                                    <Typography className="urduNotationFont" sx={{ fontSize: '15px', whiteSpace: 'nowrap' }}>
                                        مریض سے رشتہ:
                                    </Typography>
                                    <TextField
                                        name="relationWithPatient"
                                        value={formData?.consentForm?.relationWithPatient || ''}
                                        onChange={handleConsentFormChange}
                                        size="small"
                                        variant="standard"
                                        fullWidth
                                        dir="ltr"
                                        inputProps={{ dir: 'ltr', style: { direction: 'ltr', textAlign: 'left', fontSize: '15px' } }}
                                    />
                                </Box>
                            </Box>

                            <Box display="flex" gap={2} sx={{ mt: 2, flexWrap: 'wrap', alignItems: 'stretch' }}>
                                <Box
                                    dir="ltr"
                                    sx={{
                                        flex: '1 1 320px',
                                        minWidth: 0,
                                        bgcolor: '#F3F4F6',
                                        border: '1px solid #E5E7EB',
                                        borderRadius: '12px',
                                        p: 2,
                                    }}
                                >
                                <Box display="flex" alignItems="center" gap={1} sx={{ mb: 1.5 }}>
                                    <Typography sx={{ fontSize: '14px', whiteSpace: 'nowrap' }}>
                                        Doctor Name:
                                    </Typography>
                                    <TextField
                                        name="staffNameOrStamp"
                                        value={formData?.consentForm?.staffNameOrStamp || ''}
                                        onChange={handleConsentFormChange}
                                        size="small"
                                        variant="standard"
                                        fullWidth
                                    />
                                </Box>
                                <Box display="flex" alignItems="center" gap={1} sx={{ mb: 1.5 }}>
                                    <Typography sx={{ fontSize: '14px', whiteSpace: 'nowrap' }}>
                                        Designation:
                                    </Typography>
                                    <TextField
                                        name="designation"
                                        value={formData?.consentForm?.designation || ''}
                                        onChange={handleConsentFormChange}
                                        size="small"
                                        variant="standard"
                                        fullWidth
                                    />
                                </Box>
                                <Box display="flex" alignItems="center" gap={2} sx={{ mb: 2, flexWrap: 'wrap' }}>
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <Typography sx={{ fontSize: '14px' }}>Date:</Typography>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                value={formData?.consentForm?.date || null}
                                                onChange={(newValue) => {
                                                    setFormData((prev: any) => ({
                                                        ...prev,
                                                        consentForm: {
                                                            ...prev.consentForm,
                                                            date: newValue,
                                                        },
                                                    }));
                                                }}
                                                format="DD.MM.YYYY"
                                                slotProps={{
                                                    textField: {
                                                        variant: "standard",
                                                        size: "small",
                                                        sx: { width: 130 },
                                                    },
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <Typography sx={{ fontSize: '14px' }}>Time:</Typography>
                                        <TextField
                                            name="time"
                                            value={formData?.consentForm?.time || ''}
                                            onChange={handleConsentFormChange}
                                            size="small"
                                            variant="standard"
                                            placeholder="hh:mm A"
                                            sx={{ width: 110 }}
                                        />
                                    </Box>
                                </Box>
                                            <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
                                                <Typography sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                    Signature of Doctor:
                                                </Typography>
                                                <FingerprintCaptureControls
                                                    fingerprintDevice={doctorFingerprintDevice}
                                                    detectingDevice={detectingDoctorDevice}
                                                    capturingFingerprint={capturingDoctorFingerprint}
                                                    onDetect={() => detectDoctorDevice(true)}
                                                    onCapture={captureDoctorFingerprint}
                                                />
                                                <Box
                                                    dir="ltr"
                                                    sx={{
                                                        position: 'relative',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px',
                                                        width: '250px',
                                                        height: '180px',
                                                        overflow: 'hidden',
                                                        bgcolor: '#fff',
                                                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                                    }}
                                                >
                                                    {(formData?.consentForm?.submitted && formData?.consentForm?.doctorSignature) ||
                                                    (isDoctorFingerprintImage && formData?.consentForm?.doctorSignature) ? (
                                                        <>
                                                            <img
                                                                src={formData?.consentForm?.doctorSignature}
                                                                alt={isDoctorFingerprintImage ? "Doctor Fingerprint" : "Doctor Signature"}
                                                                style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '4px' }}
                                                            />
                                                            <Tooltip title="Clear Doctor Signature" placement="top" arrow>
                                                                <CancelIcon
                                                                    onClick={clearDoctorSignature}
                                                                    sx={{
                                                                        position: 'absolute',
                                                                        top: 5,
                                                                        right: 5,
                                                                        background: '#d32f2f',
                                                                        color: '#fff',
                                                                        cursor: 'pointer',
                                                                        fontSize: '18px',
                                                                        padding: '2px',
                                                                        borderRadius: '50%',
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <SignatureCanvas
                                                                ref={doctorSignatureRef}
                                                                penColor="black"
                                                                backgroundColor="transparent"
                                                                onEnd={handleDoctorSignatureEnd}
                                                                dotSize={1}
                                                                minWidth={0.5}
                                                                maxWidth={1.5}
                                                                canvasProps={{
                                                                    width: 250,
                                                                    height: 180,
                                                                    style: {
                                                                        cursor: 'crosshair',
                                                                        display: 'block',
                                                                        touchAction: 'none',
                                                                        width: '100%',
                                                                        height: '100%',
                                                                    },
                                                                }}
                                                            />
                                                            <Tooltip title="Clear Doctor Signature" placement="top" arrow>
                                                                <CancelIcon
                                                                    onClick={clearDoctorSignature}
                                                                    sx={{
                                                                        position: 'absolute',
                                                                        top: 5,
                                                                        right: 5,
                                                                        background: '#d32f2f',
                                                                        color: '#fff',
                                                                        cursor: 'pointer',
                                                                        fontSize: '18px',
                                                                        padding: '2px',
                                                                        borderRadius: '50%',
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        </>
                                                    )}
                                                </Box>
                                            </Box>
                                </Box>

                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center"
                                    gap={1}
                                    dir="rtl"
                                    sx={{
                                        flex: '1 1 280px',
                                        minWidth: '240px',
                                        bgcolor: '#F3F4F6',
                                        border: '1px solid #E5E7EB',
                                        borderRadius: '12px',
                                        p: 2,
                                    }}
                                >
                                                <Typography className="urduNotationFont" sx={{ fontSize: '15px', fontWeight: '600', direction: 'rtl', textAlign: 'center' }}>
                                                    مریض / لواحقین کے دستخط / انگوٹھا
                                                </Typography>
                                                <FingerprintCaptureControls
                                                    fingerprintDevice={fingerprintDevice}
                                                    detectingDevice={detectingDevice}
                                                    capturingFingerprint={capturingFingerprint}
                                                    onDetect={() => detectDevice(true)}
                                                    onCapture={captureFingerprint}
                                                />
                                            <Box
                                                dir="ltr"
                                                sx={{
                                                    position: 'relative',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '4px',
                                                    width: '250px',
                                                    height: '180px',
                                                    overflow: 'hidden',
                                                    bgcolor: '#fff',
                                                    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                                }}
                                            >
                                                {(formData?.consentForm?.submitted && formData?.consentForm?.signature) ||
                                                (isFingerprintImage && formData?.consentForm?.signature) ? (
                                                    <>
                                                        <img
                                                            src={formData?.consentForm?.signature}
                                                            alt={isFingerprintImage ? "Fingerprint" : "Signature"}
                                                            style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '4px' }}
                                                        />
                                                        <Tooltip title="Clear Signature" placement="top" arrow>
                                                            <CancelIcon
                                                                onClick={clearSignature}
                                                                sx={{
                                                                    position: 'absolute',
                                                                    top: 5,
                                                                    right: 5,
                                                                    background: '#d32f2f',
                                                                    color: '#fff',
                                                                    cursor: 'pointer',
                                                                    fontSize: '18px',
                                                                    padding: '2px',
                                                                    borderRadius: '50%',
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    </>
                                                ) : (
                                                    <>
                                                        <SignatureCanvas
                                                            ref={signatureRef}
                                                            penColor="black"
                                                            backgroundColor="transparent"
                                                            canvasProps={{
                                                                width: 250,
                                                                height: 180,
                                                                style: {
                                                                    cursor: 'crosshair',
                                                                    display: 'block',
                                                                    touchAction: 'none',
                                                                    width: '100%',
                                                                    height: '100%',
                                                                },
                                                            }}
                                                            onEnd={handleSignatureEnd}
                                                            dotSize={1}
                                                            minWidth={0.5}
                                                            maxWidth={1.5}
                                                        />
                                                        <Tooltip title="Clear Signature" placement="top" arrow>
                                                            <CancelIcon
                                                                onClick={clearSignature}
                                                                sx={{
                                                                    position: 'absolute',
                                                                    top: 5,
                                                                    right: 5,
                                                                    background: '#d32f2f',
                                                                    color: '#fff',
                                                                    cursor: 'pointer',
                                                                    fontSize: '18px',
                                                                    padding: '2px',
                                                                    borderRadius: '50%',
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    </>
                                                )}
                                            </Box>
                                            </Box>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', direction: 'ltr', mt: 3, gap: 2 }}>
                                <Button
                                    variant="outlined"
                                    onClick={handleConsentModalClose}
                                    sx={{ textTransform: 'uppercase' }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    sx={{ textTransform: 'uppercase' }}
                                >
                                    Submit Consent
                                </Button>
                            </Box>
                        </Box>
                    </DialogContent>
                </Dialog>


                <Dialog open={stopReasonDialogOpen} onClose={() => setStopReasonDialogOpen(false)}>
                    <DialogTitle>Please enter the Reason</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Reason"
                            type="text"
                            fullWidth
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            className="search-field"
                            size="small"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setStopReasonDialogOpen(false)}
                            sx={{
                                backgroundColor: "red",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "darkred",
                                },
                            }}
                        >
                            Cancel
                        </Button>

                        <Button onClick={handleConfirmStop} sx={{ fontSize: "0.85rem", color: "#007bff", textTransform: "capitalize" }}>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={!!selectedTransfusion} onClose={handleCloseDialog} fullWidth maxWidth="sm">
                    <DialogTitle>
                        Detail
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseDialog}
                            sx={{ position: "absolute", right: 8, top: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        {selectedTransfusion ? (
                            <Box>
                                <Typography variant="h6" align="center">
                                    {selectedTransfusion.bloodTransfusion}
                                </Typography>
                                {selectedTransfusion?.transfuse_History?.map((history: any, index: number) => (
                                    <Box key={index} mb={2}>
                                        <Typography variant="body2">
                                            {history.status === "started" ? "Started at" : "Stopped at"}: {history?.date_Time}
                                        </Typography>
                                        <Typography variant="body2">By: {history?.doctorName}</Typography>
                                        {history?.reason && (
                                            <Typography variant="body2" sx={{ fontStyle: "italic" }}>
                                                Reason: {history?.reason}
                                            </Typography>
                                        )}
                                    </Box>
                                ))}
                            </Box>
                        ) : (
                            <Typography variant="body2" align="center">
                                No details available.
                            </Typography>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog} sx={{ fontSize: "0.8rem", color: "#007bff", textTransform: "capitalize" }}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box >

            <Dialog open={openStopDialog}>
                <DialogContent>
                    <Typography>Are you sure you want to stop this medicine?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelStop} color="primary">
                        No
                    </Button>
                    <Button onClick={handleStopMedicine} variant="contained" color="primary">
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openDelMed} onClose={handleCloseStopDialog} maxWidth="md" fullWidth>
                <DialogContent>
                    <Box>
                        <Typography variant="h6" gutterBottom sx={{ fontSize: '13px' }}>
                            Stopped Medicines History
                        </Typography>
                        <Tabs value={selectedTab} onChange={handleTabChange} aria-label="Deleted Medicines" variant={"scrollable"}>
                            {formData?.stopped_medicines && Array.isArray(formData?.stopped_medicines) && formData?.stopped_medicines.length > 0 ? (
                                formData?.stopped_medicines.map((medicine: any, index: any) => (
                                    <Tab key={index} label={medicine?.name} />
                                ))
                            ) : (
                                <Typography>No Stopped Medicines Available</Typography>
                            )}
                        </Tabs>

                        {/* Check if the selectedTab is within the bounds of stopped_medicines */}
                        {formData?.stopped_medicines && formData?.stopped_medicines?.length > 0 && formData?.stopped_medicines[selectedTab] && (
                            <Box p={1}>
                                {/* <Typography variant="h6" gutterBottom>
                                    Medicine History for: {formData?.stopped_medicines[selectedTab]?.name}
                                </Typography> */}
                                {Array.isArray(formData?.stopped_medicines[selectedTab]?.med_History) &&
                                    formData?.stopped_medicines[selectedTab]?.med_History?.length > 0 ? (
                                    formData?.stopped_medicines[selectedTab]?.med_History?.map((item: any, idx: any) => {
                                        return (
                                            <Box key={idx}>
                                                <Box display="flex" alignItems="center" gap={2}>
                                                    <span style={{ fontSize: '10px', fontWeight: '600' }}>{idx + 1}:</span>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '10px',
                                                            color: item?.status === 'stopped' ? 'red' : 'gray',
                                                            textTransform: 'capitalize',
                                                        }}
                                                    >
                                                        {item?.status} By {item?.doctorName} at: {item?.date_Time}
                                                    </Typography>
                                                </Box>
                                                <Divider sx={{ width: '100%', mb: 0.2 }} />
                                            </Box>
                                        );
                                    })
                                ) : (
                                    <Typography sx={{ fontSize: '10px', color: 'gray' }}>No History Available</Typography>
                                )}
                            </Box>
                        )}
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseStopDialog} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={completionDialogOpen} onClose={() => setCompletionDialogOpen(false)} maxWidth='xs' fullWidth>
                <DialogTitle>Complete Transfusion</DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        label="Completion Notes"
                        type="text"
                        fullWidth
                        multiline
                        rows={3}
                        value={completionNotes}
                        onChange={(e) => setCompletionNotes(e.target.value)}
                        size="small"
                        disabled={formData.transfusion.find((t: any) => t.id === selectedTransfusionId)?.action === "completed"}
                    />
                    <Box display='flex' alignItems='center' justifyContent='space-between' gap={1}>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Doctor Name"
                            type="text"
                            fullWidth
                            value={doctorName || Adminprofile?.data?.firstName ||""}
                            onChange={(e) => setDoctorName(e.target.value)}
                            size="small"
                            // disabled={formData.transfusion.find((t: any) => t.id === selectedTransfusionId)?.action === "completed"}
                            disabled
                        />
                        <TextField
                            margin="dense"
                            label="Completion Time"
                            type="text"
                            fullWidth
                            value={completionTime}
                            onChange={(e) => setCompletionTime(e.target.value)}
                            size="small"
                            // disabled={formData.transfusion.find((t: any) => t.id === selectedTransfusionId)?.action === "completed"}
                            disabled
                        />
                    </Box>

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setCompletionDialogOpen(false)} sx={{ color: "red" }}>
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmCompletion} sx={{ color: "blue" }}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    )
}

export default TreamentChart;

